var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgRewind = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.941,
    height: 10.015,
    viewBox: "0 0 13.941 10.015",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7577",
    "data-name": "Group 7577",
    transform: "translate(-99.182 -152.993)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Arrow-left-3",
    d: "M674.553,1516.016l3.58-3.717a1.15,1.15,0,0,1,1.922.853v7.71a1.15,1.15,0,0,1-1.922.852l-3.58-3.716A1.338,1.338,0,0,1,674.553,1516.016Z",
    transform: "translate(-574.933 -1359.006)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Arrow-left-3-2",
    "data-name": "Arrow-left-3",
    d: "M674.553,1516.016l3.58-3.717a1.15,1.15,0,0,1,1.922.853v7.71a1.15,1.15,0,0,1-1.922.852l-3.58-3.716A1.338,1.338,0,0,1,674.553,1516.016Z",
    transform: "translate(-566.933 -1359.006)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRewind);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMy45NDEiIGhlaWdodD0iMTAuMDE1IiB2aWV3Qm94PSIwIDAgMTMuOTQxIDEwLjAxNSI+CiAgPGcgaWQ9Ikdyb3VwXzc1NzciIGRhdGEtbmFtZT0iR3JvdXAgNzU3NyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTk5LjE4MiAtMTUyLjk5MykiPgogICAgPHBhdGggaWQ9IkFycm93LWxlZnQtMyIgZD0iTTY3NC41NTMsMTUxNi4wMTZsMy41OC0zLjcxN2ExLjE1LDEuMTUsMCwwLDEsMS45MjIuODUzdjcuNzFhMS4xNSwxLjE1LDAsMCwxLTEuOTIyLjg1MmwtMy41OC0zLjcxNkExLjMzOCwxLjMzOCwwLDAsMSw2NzQuNTUzLDE1MTYuMDE2WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTU3NC45MzMgLTEzNTkuMDA2KSIgZmlsbD0iI2ZmZiIgZmlsbC1ydWxlPSJldmVub2RkIi8+CiAgICA8cGF0aCBpZD0iQXJyb3ctbGVmdC0zLTIiIGRhdGEtbmFtZT0iQXJyb3ctbGVmdC0zIiBkPSJNNjc0LjU1MywxNTE2LjAxNmwzLjU4LTMuNzE3YTEuMTUsMS4xNSwwLDAsMSwxLjkyMi44NTN2Ny43MWExLjE1LDEuMTUsMCwwLDEtMS45MjIuODUybC0zLjU4LTMuNzE2QTEuMzM4LDEuMzM4LDAsMCwxLDY3NC41NTMsMTUxNi4wMTZaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNTY2LjkzMyAtMTM1OS4wMDYpIiBmaWxsPSIjZmZmIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KICA8L2c+Cjwvc3ZnPgo=";